const RELOAD_FLAG = 'webfunnel:stale-chunk-reload';

const isSessionAvailable = (): boolean => {
  try {
    return typeof sessionStorage !== 'undefined';
  } catch {
    return false;
  }
};

/**
 * After a deploy the cached index.html still points at chunk hashes that no longer exist on the CDN —
 * the first lazy `import()` then dies with "Failed to fetch dynamically imported module" and takes the
 * whole funnel down. Vite reports this as `vite:preloadError`; one reload fetches the fresh index.
 * Guarded by a session flag so a genuinely missing chunk does not loop.
 */
export const installStaleChunkReload = (win: Window = window): void => {
  win.addEventListener('vite:preloadError', (event) => {
    if (!isSessionAvailable()) return;
    if (sessionStorage.getItem(RELOAD_FLAG)) return;
    sessionStorage.setItem(RELOAD_FLAG, String(Date.now()));
    event.preventDefault();
    win.location.reload();
  });
  // A successful load clears the guard so the next deploy can reload again.
  if (isSessionAvailable()) {
    win.addEventListener('load', () => sessionStorage.removeItem(RELOAD_FLAG), { once: true });
  }
};
